import type { CustomFieldScope } from '@/api/entity_types/CustomField';

type Scope = {
  key: CustomFieldScope;
  label: string;
};

const scopes: Scope[] = [
  { key: 'contact:candidate', label: 'Candidate' },
  { key: 'contact:teammate', label: 'Teammate' },
];

export const list = (): Scope[] => [...scopes];

export const find = (key: CustomFieldScope): Scope =>
  scopes.find(scope => scope.key === key) ?? scopes[0];
